<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="my-2 flex align-items-center">
        <div>
          <patron-filter-widget
            [findOptions]="findOptions"
            (onSubmit)="goToFirstPage()"></patron-filter-widget>
        </div>
      </div>
      <div class="my-2 flex align-items-center">
        <patron-search-widget
          (onSearch)="onSearch($event)"
          #searchWidget
          class="me-2"></patron-search-widget>
        @if (isEnableNewProfile()) {
          <patron-button iconName="pi-plus" [routerLink]="['/perfis/criar']">
            Novo perfil
          </patron-button>
        }
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <patron-responsive-table
    [bodyTemplate]="tableBody"
    [headerTemplate]="tableHeader"
    [items]="profiles"
    [findOptions]="findOptions"
    [loading]="loading"
    (sortChanged)="paginate($event)"
    [mobileSortable]="false"
    #table>
    <ng-template #tableHeader>
      <tr>
        <th>Perfil</th>
        <th class="text-center md:text-center">Tipo</th>
        <th class="text-center md:text-center">Padrão</th>
      </tr>
    </ng-template>
    <ng-template #tableBody let-item let-index="index">
      <tr (click)="onRowClicked(item)">
        <td class="md:text-center">
          <patron-rt-column-title>
            <strong>Perfil</strong>
          </patron-rt-column-title>
          <span class="flex flex-wrap align-items-center justify-content-between">
            <span [innerHTML]="item.name | highlight: findOptions.q!"></span>
          </span>
        </td>
        <td class="text-center md:text-center">
          <patron-rt-column-title>
            <strong>Tipo</strong>
          </patron-rt-column-title>
          @if (item.type == 'U') {
            <patron-badge [color]="patronUtils.getAccessTypeColor('user')" class="ms-1">
              {{ patronUtils.getAccessTypeLabel('user') }}
            </patron-badge>
          }
          @if (item.type == 'C') {
            <patron-badge [color]="patronUtils.getAccessTypeColor('customer')" class="ms-1">
              {{ patronUtils.getAccessTypeLabel('customer') }}
            </patron-badge>
          }
          @if (item.type == 'S') {
            <patron-badge [color]="patronUtils.getAccessTypeColor('supplier')" class="ms-1">
              {{ patronUtils.getAccessTypeLabel('supplier') }}
            </patron-badge>
          }
        </td>
        <td class="text-center md:text-center">
          <patron-rt-column-title>
            <strong>Padrão</strong>
          </patron-rt-column-title>
          <patron-switch
            [(ngModel)]="item.default"
            [trueValue]="1"
            [falseValue]="0"
            (click)="toggleDefault($event, item, index)">
          </patron-switch>
        </td>
      </tr>
    </ng-template>
  </patron-responsive-table>
</div>

<patron-toolbar position="bottom" [class.hidden]="!profiles.length">
  <patron-paginator
    [totalRecords]="totalItems"
    [findOptions]="findOptions"
    (onPageChange)="paginate($event)"
    #paginator>
  </patron-paginator>
</patron-toolbar>
